<template>
	<div v-editable="blok" class="mb-6 md:mb-10">
		<div class="relative pb-[56.25%] embed-content" v-html="blok.embedCode" />
	</div>
</template>

<script setup lang="ts">
	import type {EmbedContentStoryblok} from '@/storyblok/types';

	interface Props {
		blok: EmbedContentStoryblok
	}
	defineProps<Props>();
</script>

<style scoped>
	@reference "../../assets/css/main.css";

	.embed-content :deep(iframe, object, embed) {
		@apply absolute inset-0 w-full h-full;
	}
</style>
